import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllHarvests = async (filters, page, size) => {
  try {
    const response = await api.get(`/harvest`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createHarvest = async (harvestData) => {
  try {
    const response = await api.post('/harvest', harvestData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao cadastrar dados da safra.');
  }
};

export const getHarvestData = async (harvestId) => {
  try {
    const response = await api.get(`/harvest/${harvestId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados da safra.');
  }
};

export const updateHarvest = async (harvestId, data) => {
  try {
    const response = await api.put(`/harvest/${harvestId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar a safra.');
  }
};